import { Col, Input, Row, Typography } from "antd";
import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionClaim } from "../../../../../../redux/slices/claim";

const { setClaimItemValueBom } = actionClaim;

const InputLot = ({ disabled }) => {
  const dispatch = useDispatch();
  const product_key = useSelector(
    (state) => state.claim.productModal.product_key
  );
  const product_bom_key = useSelector(
    (state) => state.claim.productBomModal.product_bom_key
  );
  const lot = useSelector((state) => {
    if (!product_key || !product_bom_key) return null;
    const { activeKey, itemByKey } =
      state.claim.billProduct.itemByKey[product_key].claim_item;
    const { activeKey: activeKeyBom, itemByKey: itemByKeyBom } =
      itemByKey[activeKey].bom.itemByKey[product_bom_key].claim_item;
    return itemByKeyBom[activeKeyBom].lot;
  });

  return (
    <Row gutter={[8, 8]}>
      <Col span={6} className="text-right">
        <Typography.Text>Lot.</Typography.Text>
      </Col>
      <Col span={18}>
        <Input
          size="small"
          autoComplete="off"
          placeholder="ล็อตการผลิต"
          maxLength={50}
          value={lot}
          disabled={disabled}
          onChange={(e) =>
            dispatch(setClaimItemValueBom({ lot: e.target.value }))
          }
        />
      </Col>
    </Row>
  );
};

export default memo(InputLot);
